// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable object-shorthand */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-console */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-undef */
/**
 * File for the blog.
 *
 */

// Make sure everything is loaded first.
document.addEventListener( 'DOMContentLoaded', () => filterAjax( jQuery ) );

/**
 * AJAX Filter Functionality
 *
 * @param {Object} $ jQuery.
 *
 * @author Julian
 */
function filterAjax( $ ) {
	$( document ).ready( () => {
		//Filter Ajax Event
		const filterables = document.querySelectorAll(
			'.categories-filter .filterable'
		);

		const linkContainers = document.querySelectorAll(
			'.categories-filter .category-link-container'
		);

		filterables.forEach( ( filterable ) => {
			filterable.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				const catValue = filterable.dataset.term ?? 'all';

				document.querySelector(
					'.articles-container'
				).dataset.currentcat = catValue;
				runAjax( catValue );
			} );
		} );

		function runAjax( catValue ) {
			$.ajax( {
				// eslint-disable-next-line camelcase
				url: filter_ajax_params.ajax_url,
				data: {
					action: 'filter',
					cat_value: catValue,
					// eslint-disable-next-line camelcase
					security: filter_ajax_params.security, // Include the security nonce
				},
				cache: false,
				type: 'POST',
				success: function ( result ) {
					// Assuming 'result' contains HTML, render it in the container.
					$( '.articles-container' ).html( result.data );
				},
				error: function ( error ) {
					console.error( 'Error: ', error );
				},
			} );
		}

		linkContainers.forEach( ( linkContainer ) => {
			linkContainer.addEventListener( 'click', () => {
				removeActiveClasses( linkContainers );
				linkContainer.classList.add( 'active' );
			} );
		} );

		const removeActiveClasses = ( elements ) => {
			elements.forEach( ( element ) => {
				element.classList.remove( 'active' );
			} );
		};
	} );
}
